<template>
	<div class="container">
		<header>
			<div class="logo-wrapper desktop">
				<a href="/">
					<img src="@/assets/images/logo.svg" alt="Magazyn Pismo"/>
				</a>
			</div>
		</header>

		<div class="password-form c-bg-white">

			<transition name="fade" mode="out-in">

				<template  v-if="resetSuccess">
					<div>
						<h1 class="font-size-h3 font-marat c-gray pb-2 mb-4 bb-1">{{ $content.reset_password.title }}</h1>
						<p class="c-gray">{{ $content.reset_password.success }}</p>
					</div>
				</template>

				<template v-else>
					<ValidationObserver
						id="resetpassform"
						autocomplete="off"
						tag="form"
						v-slot="{ handleSubmit }"
						@submit.prevent
					>
						<h1 class="font-size-h3 font-marat c-gray pb-2 mb-4 bb-1">{{ $content.reset_password.title }}</h1>

						<div class="mb-5">
							<p class="c-pink" v-if="resetError === 'custom'" v-html="errorMessage"></p>
							<p class="c-pink" v-else-if="resetError === 'default'">{{ $content.reset_password.error.default }}</p>
							<p class="c-gray" v-else>{{ $content.reset_password.desc }}</p>
						</div>

						<div class="mb-3">
							<label for="resetPasswordEmail" class="label">{{ $content.your_email }}:</label>
							<ValidationProvider rules="required|email" v-slot="{ errors }">
								<input
									autocomplete="off"
									id="resetPasswordEmail"
									type="text"
									class="form-control"
									v-model="userEmail">
								<p class="form-error">{{ errors[0] }}</p>
							</ValidationProvider>
						</div>

						<button
							@click="handleSubmit(resetPassword)"
							type="submit"
							class="btn btn-primary btn-max mt-4">
							<span class="loader" v-if="resetInProgress"></span>
							<span v-else>{{ $content.reset_password.button }}</span>
						</button>
					</ValidationObserver>
				</template>
			</transition>

		</div>
	</div>
</template>

<script>
	import { ValidationProvider, ValidationObserver } from 'vee-validate';

	export default {
		name: 'ResetPasswordForm',
		components: {
			ValidationProvider,
			ValidationObserver
		},
		data() {
			return {
				userEmail: '',
				resetInProgress: false,
				resetError: false,
				resetSuccess: false,
				errorMessage: ''
			}
		},
		methods: {
			resetPassword() {
				const URL = `https://magazynpismo.pl/wp-admin/admin-ajax.php?action=reset_pass_init&email=${this.userEmail}&target=reset`;
				this.resetInProgress = true;

				this.$http.get(URL)
					.then(res => {
						if (res.data.status === 'success') {
							this.resetSuccess = true;
						}
						else if (res.data.status === 'error') {
							this.resetError = 'custom';
							this.errorMessage = res.data.message;
						}
						this.resetInProgress = false;
					})
					.catch(err => {
						this.resetInProgress = false;
						this.resetError = 'default';
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.logo-wrapper {
		padding: 0 40px;
		overflow: hidden;
		max-width: 320px;
		margin: 30px auto 60px;

		img {
			width: 100%;
		}
	}
</style>

